import { PageType } from '@dtx-company/flow-codegen/src/page/typeUtils'
import { RootPageState } from '../../redux/types'
import { usePageSelector } from '../usePageSelector'

export const useCurrentTempPage = (): PageType | null => {
  return usePageSelector((state: RootPageState) => state.pageEditorReducer.tempPage)
}
